export function getUniswapNFTUrl(tokenId: number) {
  return 'https://app.uniswap.org/#/pool/' + tokenId
}
